// extracted by mini-css-extract-plugin
export default {"pageWrapper":"privacyPolicy_pageWrapper__XSkMU","bgImage":"privacyPolicy_bgImage__jpxOK","privacyContainer":"privacyPolicy_privacyContainer__HQgvU"};